import type { UseMutationOptions } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

import { sendJson } from '@hcr/api/shared'

import type { HoldingBookingPayloadDto, ProblemDetailsDto } from '../../dtos'
import type { AuthorizedRequestParams } from '../../models'
import { createAuthorizationHeader } from '../../utils'

export const createHoldingBookingMutation =
  (baseUrl: string) =>
  (
    { idToken }: AuthorizedRequestParams,
    options?: Partial<UseMutationOptions<void, ProblemDetailsDto, HoldingBookingPayloadDto>>
  ) =>
    useMutation<void, ProblemDetailsDto, HoldingBookingPayloadDto>({
      ...options,
      mutationFn: body =>
        sendJson({
          body,
          headers: createAuthorizationHeader(idToken),
          method: 'POST',
          url: `${baseUrl}/user/holdings/reserve`,
        }),
    })
